module.exports = __webpack_public_path__ + "media/hematin.0847088c.wav";